import { Suspense } from 'react';
import CartCrossSellFull from '../cart/cartCrossSellFull';
import { getRecommendationsFromCart } from '../cart/recommendation-utils';
import Editorial from './Editorial';

export default async function CartCrossSellFullParent({
  cartFromServer,
  block,
  position,
  crossSell
}) {
  const recommendations =
    cartFromServer?.lines?.length > 0
      ? await getRecommendationsFromCart(cartFromServer)
      : { products: [] };

  // Return the editorial as a fallback if there are no recommendations
  const placeholder = {
    editorial: {
      reference: [block.cart_cross_sell_full.placeholder_component?.[0]]
    }
  };
  if (!placeholder) {
    console.warn('No placeholder component found for editorial.');
  }

  return (
    <CartCrossSellFull
      block={block}
      crossSell={crossSell}
      position={position}
      cartFromServer={cartFromServer}
      initialRecommendations={recommendations}
    >
      <Suspense>
        <Editorial block={placeholder} position={position} />
      </Suspense>
    </CartCrossSellFull>
  );
}
